var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$vuetify.breakpoint.mdAndUp)?_c('v-flex',{attrs:{"md4":"","text-right":"","id":"coupon-img"}},[_c('img',{staticClass:"img-coupon",attrs:{"src":_vm.getCouponImageUrl,"alt":"image-coupon"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }